/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Image } from "antd";
import PopOverCrewChange from "../PopOverCrewChange";

function PopOverCrew(props: any) {
  const { column, editCrew, crewDrop, setEditCrew, allColumns, setColumns } =
    props;

  const removeCrewMember = (memberId: string, columnId: string) => {
    // Find the column to update
    const updatedColumns = allColumns.map((col: any) => {
      if (col.id === columnId) {
        return {
          ...col,
          crewMembers: col.crewMembers.filter(
            (member: any) => member.id !== memberId
          ),
        };
      }
      return col;
    });
    setColumns(updatedColumns);
  };

  return (
    <div className="crewPopoverContent">
      <div className="crewPopTop">
        <h4>Crew details</h4>
        <Button
          className={editCrew ? "editCrewDone" : "editCrewBtn"}
          onClick={(e) => {
            e.stopPropagation();
            setEditCrew(!editCrew);
          }}
          type={editCrew ? "primary" : "text"}
        >
          {editCrew ? (
            "Done"
          ) : (
            <Image src="/images/schedule/edit.svg" preview={false} />
          )}
        </Button>
      </div>
      <div className="crewPopDetail">
        {column?.crewMembers?.map((member: any) => (
          <div key={member.id} className="crewPopItem">
            <div className="crewWithAvatar">
              <div className="imageWrapper">
                <Image src={member?.image} preview={false} />
                {member.crewLeader && (
                  <div className="statusIndicator">
                    <Image
                      src="/images/schedule/leader-star.svg"
                      preview={false}
                    />
                  </div>
                )}
              </div>
              <div className="crewPopName">
                <div className="name">{member.name}</div>
                {member.role && <div className="role">{member.role}</div>}
              </div>
            </div>

            {editCrew ? (
              <div style={{ height: "32px" }}>
                {member.crewLeader ? (
                  <Button
                    className="btn-sm"
                    icon={
                      <Image
                        src="/images/schedule/leader-icon.svg"
                        preview={false}
                      />
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      padding: "2px 0",
                    }}
                  >
                    <Button
                      className="btn-sm"
                      icon={
                        <Image
                          src="/images/schedule/remove-btn.svg"
                          preview={false}
                        />
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                        removeCrewMember(member.id, column.id);
                      }}
                    />

                    <PopOverCrewChange
                      crewDrop={crewDrop}
                      memberId={member.id}
                      allColumns={allColumns}
                      setColumns={setColumns}
                      crewLeaderId={member.crewLeaderId}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="crewPopPunchedIn">
                {member.punchedIn ? (
                  <div className="punchedIn">
                    Punched in, {member.punchedIn}
                  </div>
                ) : member.latePunchedIn ? (
                  <div
                    className="noShow"
                    style={{
                      color: "#F06400",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Image
                      src="/images/schedule/late-indicator.svg"
                      preview={false}
                    />{" "}
                    Punched in, {member.latePunchedIn}
                  </div>
                ) : (
                  <div className="noShow">No show</div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default PopOverCrew;
